import { render, staticRenderFns } from "./ItemSelecaoCor.vue?vue&type=template&id=0fc69752"
import script from "./ItemSelecaoCor.vue?vue&type=script&lang=js"
export * from "./ItemSelecaoCor.vue?vue&type=script&lang=js"
import style0 from "./ItemSelecaoCor.vue?vue&type=style&index=0&id=0fc69752&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports